import CommencementStatus from '../enums/CommencementStatus'
import { getSliders, getTeachingCalendars } from '../services/vu'
import { calculateDefaultSlide } from '../helpers/week'
import { fetchEnrolledTeachingPeriodsIfNeeded } from './enrolledTeachingPeriods'

export const fetchSlidersIfNeeded = (courseId, parentSSPNo) => {
  return (dispatch, getState) => {
    if (shouldFetchSliders(getState(), courseId)) {
      return dispatch(fetchSliders(courseId, parentSSPNo))
    } else {
      return Promise.resolve()
    }
  }
}

const shouldFetchSliders = (state, courseId) => {
  const { isFetching, receivedAt } = state.sliders[courseId]
  return receivedAt === null && !isFetching
}

const fetchSliders = (courseId, parentSSPNo) => {
  return (dispatch, getState) => {
    dispatch(requestSliders(courseId))

    return dispatch(fetchEnrolledTeachingPeriodsIfNeeded(courseId, parentSSPNo)).then(() => {
     
      const {
        courses: { data },
        course: {selectedCourse},
        enrolledTeachingPeriods
      } = getState()
      const {
        admissionCategory,
        courseAttemptStatus
      } = data[courseId]

      const {
        locationCd,
        commencementDate,
        isCommencing,
        courseSpkCatLvlCd
      } = selectedCourse

      const { teachingPeriods } = enrolledTeachingPeriods[courseId]
      //sending admission category and degreeLevel flag PG or UG as array to filter slider
      const cohort = [admissionCategory]
      if (courseSpkCatLvlCd && courseSpkCatLvlCd != null) {
        cohort.push(courseSpkCatLvlCd)
      }
      return getSliders(
        courseId,
        cohort,
        courseAttemptStatus,
        teachingPeriods,
        locationCd
      )
        .then((payload = []) => {
          // Filter out slider items that aren't published
          const sliders = payload.map(slider => {
            return {
              ...slider,
              sliderItems: slider.sliderItems.filter(sliderItem => {
                return sliderItem.status
              })
            }
          })
//
//          // Rolling Enrolments: Filter out slider items with teaching periods
//          // before the student's course commencement date.
//          if (
//              isCommencing && commencementDate
//          ) {
//            return getTeachingCalendars('', commencementDate).then(
//              (teachingCalendars = []) => {
//                // Teaching periods that are before the student's course
//                // commencement date
//                const teachCalTypes = teachingCalendars.map(
//                  ({ teachCalType }) => teachCalType
//                )
//
//                if (teachCalTypes.length > 0) {
//                  return sliders.map(slider => {
//                    if (slider.groupByTeachingPeriod) {
//                      return {
//                        ...slider,
//                        sliderItems: slider.sliderItems.filter(sliderItem => {
//                          return teachCalTypes.some(
//                            teachCalType =>
//                              sliderItem.teachingPeriod.calendarType !==
//                              teachCalType
//                          )
//                        })
//                      }
//                    } else {
//                      return slider
//                    }
//                  })
//                }
//
//                return sliders
//              }
//            )
//          }
          return sliders
       })
        .then((payload = []) => {
          const sliders = payload.map(slider => {
            const sliderItems = slider.sliderItems
              .filter(({ commencementStatuses = [] }) => {
                // Filter out slider items that doesn't match the student's
                // course commencement status, e.g. don't show "commencing"
                // slider items if the student is a "continuing" student
                return (
                  commencementStatuses.length === 0 ||
                  commencementStatuses.some(({ machineCode }) => {                    
                    return machineCode === (isCommencing? 'Y':'N')
                  })
                )
              })
              .filter(sliderItem => {
                // Filter out slider items that don't match the teaching periods
                // attached to the parent slider, e.g. filter all "SEM-1" slider
                // items if the parent slider is "SEM-2"
                if (!slider.groupByTeachingPeriod) {
                  return true
                }

                if (sliderItem.teachingPeriod) {
                  return slider.teachingPeriods.some(sliderTeachingPeriod => {
                    return (
                      sliderTeachingPeriod.calendarType ===
                      sliderItem.teachingPeriod.calendarType
                    )
                  })
                }

                return false
              })
              .filter(sliderItem => {
                // Filter out all the orientation slider items except the ones
                // that match the earliest teaching period attach to the slider.
                if (
                  sliderItem.orientation &&
                  slider.teachingPeriods.length > 0
                ) {
                  const startingTeachingPeriod = slider.teachingPeriods[0]

                  return (
                    sliderItem.teachingPeriod.calendarType ===
                    startingTeachingPeriod.calendarType
                  )
                }

                return true
              })

            return {
              ...slider,
              defaultSlide: calculateDefaultSlide(
                sliderItems,
                slider.groupByTeachingPeriod,
                commencementDate
              ),
              sliderItems: sliderItems
            }
          })

          // Filter out sliders that don't have any slider items
          const slidersWithSliderItems = sliders.filter(
            slider => slider.sliderItems.length > 0
          )

          return dispatch(receiveSliders(courseId, slidersWithSliderItems))
        })
    })
  }
}

export const selectDefaultSlide = courseId => {
  return {
    type: 'SELECT_DEFAULT_SLIDE',
    courseId
  }
}

export const selectSlide = (courseId, slideId) => {
  return {
    type: 'SELECT_SLIDE',
    courseId,
    slideId
  }
}

const requestSliders = courseId => {
  return {
    type: 'REQUEST_SLIDERS',
    courseId
  }
}

const receiveSliders = (courseId, sliders) => {
  return {
    type: 'RECEIVE_SLIDERS',
    courseId,
    sliders
  }
}
